import axios from 'axios';
import { API_URL } from '../config/api';

// Define the interface to match the backend entity
export interface HeroSlide {
    id: number;
    image: string;
    subtitle: string;
    title: string;
    description: string;
    ctaText: string;
    ctaLink: string;
    order: number;
}

const getUrl = () => {
    return `${API_URL}/hero-slides`;
};

export const heroSlidesService = {
    getAll: async (): Promise<HeroSlide[]> => {
        const response = await axios.get<HeroSlide[]>(getUrl());
        return response.data;
    },

    create: async (slide: FormData | Omit<HeroSlide, 'id'>): Promise<HeroSlide> => {
        const response = await axios.post<HeroSlide>(getUrl(), slide, {
            headers: {
                'Content-Type': slide instanceof FormData ? 'multipart/form-data' : 'application/json',
            },
        });
        return response.data;
    },

    update: async (id: number, slide: FormData | Partial<HeroSlide>): Promise<HeroSlide> => {
        const response = await axios.patch<HeroSlide>(`${getUrl()}/${id}`, slide, {
            headers: {
                'Content-Type': slide instanceof FormData ? 'multipart/form-data' : 'application/json',
            },
        });
        return response.data;
    },

    delete: async (id: number): Promise<void> => {
        await axios.delete(`${getUrl()}/${id}`);
    },
};
